import { fetchEventSource } from "@microsoft/fetch-event-source";
import axios from "axios";
import { Mention } from "primereact/mention";
import { Skeleton } from "primereact/skeleton";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { ThreeDots } from "react-loader-spinner";
import { useLocation, useNavigate } from "react-router-dom";
import CommunicationIcon from "../Assets/Images/communication-icon.svg";
import AnswerIcon from "../Assets/Images/nc.png";
import Answer from "../Bot-components/Answer";
import Header from "../Common/Header";
import CommonValues from "../Common/Utils";
import SupportLoader from "../CommonControls/SupportLoader";
// import NCChatBotConversationHistory from "./NCChatBotConversationHistory";
import { marked } from "marked";

interface ChatResponse {
  conversationId: string;
  answer: string;
  sources: string[];
  imageURLs: string[];
  videoURLs: string[];
  imageSidebar: boolean;
  question: string;
  chatId: string;
  like: boolean;
  disLike: boolean;
  feedback: string;
  showFeedback: boolean;
  feedbackLoading: boolean;
  plotlyData: { data: string; layout: string };
  textToAction: string;
  responseStreaming: boolean;
}

class ChatRequest {
  ConversationId: string = "";
  ChatHistory: { Question: string; Answer: string }[] = [];
  Question: string = "";
}

interface UploadFileResponse {
  fileURL: string;
  fileName: string;
}

export default function NCInsuredContextChat() {
  const [question, setQuestion] = useState("");
  const [insuredName, setInsuredName] = useState("");
  const [questionLoading, setQuestionLoading] = useState(false);
  const [sendQuestion, setSendQuestion] = useState(true);
  const [recordingAudio, setRecordingAudio] = useState(false);
  const [transcribingAudio, setTranscribingAudio] = useState(false);
  const [conversationLoading, setConversationLoading] = useState(false);
  const [showConversationHistory, setShowConversationHistory] = useState(false);
  const [chatResponses, setChatResponses] = useState<ChatResponse[]>([]);
  const [uploadFileResponses, setUploadFileResponses] = useState<
    UploadFileResponse[]
  >([]);
  const [uploadFile, setUploadFile] = useState<File[]>([]);
  const [uploadFileToBlobLoading, setUploadFileToBlobLoading] = useState(false);
  const [dragOver, setDragOver] = useState(false);
  const [avatarName, setAvatarName] = useState<string | null>("");
  const toast: any = useRef("");
  const navigate = useNavigate();
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);
  const chatContainerRef = useRef<HTMLDivElement>(null);
  const [isFocused, setIsFocused] = useState(false);

  const [audioRecorder, setAudioRecorder] = useState<MediaRecorder | null>(
    null
  );
  const [bottomPadding, setBottomPadding] = useState(0);

  const location = useLocation();
  const [chatBotEmbeded, setChatBotEmbeded] = useState(
    location.state?.embeded || window.location.pathname.endsWith("embeded")
  );
  const [insuredDatabaseId, setInsuredDatabaseId] = useState(
    location.state?.insuredDatabaseId || localStorage.getItem("InsuredDatabaseId") || ""
  );
  const [suggestions, setSuggestions] = useState([
    { name: "Rater Agent", nickname: "RaterAgent" },
    { name: "Talk To Database", nickname: "TalkToAmsAgent" },
  ]);

  const onFreshDeskClick = () => {
    const parentOrigin = window.location.ancestorOrigins[0];
    if (!parentOrigin) {
      console.error("Cannot determine parent origin for postMessage.");
      return;
    }
    const availableCount = 1;
    window.parent.postMessage(
      {
        type: "showFreshChat",
        payload: { count: availableCount },
      },
      parentOrigin
    );
  };

  const [isPinned, setIsPinned] = useState(true);

   const onPinToggleClick = () => {
    const newPinned = !isPinned;
    setIsPinned(newPinned);
    if (newPinned) {
      console.log("Message sent: CLIENT_MOMENTUM_AI_CHAT_PIN");
    } else {
      console.log("Message sent: CLIENT_MOMENTUM_AI_CHAT_UNPIN");
      const parentOrigin = window.location.ancestorOrigins[0];
      if (!parentOrigin) {
        console.error("Cannot determine parent origin for postMessage.");
        return;
      }
      window.parent.postMessage(
        { type: "CLIENT_MOMENTUM_AI_CHAT_UNPIN" },
        parentOrigin
      );
    }
  };
  
  const suggestedQuestions = [
    "Create a task in AMS for the insured",
    "Show all policies for the insured in AMS",
    "Create a note in AMS for the insured",
    "Add a driver to the insured in AMS",
    "Create an opportunity in AMS for the insured",
  ];

  // Keep all your existing useEffect hooks and functions exactly as they are
  useEffect(() => {
    const updatePadding = () => {
      const screenHeight = window.innerHeight;
      let paddingPercentage;

      if (screenHeight >= 850) {
        paddingPercentage = 0.62;
      } else if (screenHeight >= 600) {
        paddingPercentage = 0.55;
      } else {
        paddingPercentage = 0.5;
      }
      const calculatedPadding = screenHeight * paddingPercentage;
      setBottomPadding(calculatedPadding);
    };

    updatePadding();
    window.addEventListener("resize", updatePadding);

    return () => window.removeEventListener("resize", updatePadding);
  }, []);

  useEffect(() => {
    const updateMarginBottom = () => {
      const screenHeight = window.innerHeight;
      let marginPercentage;

      if (screenHeight >= 850) {
        marginPercentage = 0.62;
      } else if (screenHeight >= 600) {
        marginPercentage = 0.55;
      } else {
        marginPercentage = 0.5;
      }

      const calculatedMargin = screenHeight * marginPercentage;

      document.documentElement.style.setProperty(
        "--dynamic-margin-bottom",
        `${calculatedMargin}px`
      );
    };

    updateMarginBottom();
    window.addEventListener("resize", updateMarginBottom);

    return () => window.removeEventListener("resize", updateMarginBottom);
  }, []);

  useEffect(() => {
    let token = CommonValues.GetToken();
    if (token == "" || token == null) {
      CommonValues.Logout(navigate);
    }
    localStorage.setItem("Embeded", String(chatBotEmbeded));

    setChatBotEmbeded(localStorage.getItem("Embeded") === "true");

    getConversationHistory(window.location.href.split("/")[5]);

    adjustTextareaHeight();
    setAvatarName(localStorage.getItem("AvatarName"));
    setUploadFileResponses([]);
    getInsuredDetails(insuredDatabaseId);
  }, [window.location.href.split("/")[5]]);

  const getInsuredDetails = (insuredDatabaseId: string | null) => {
    if (
      insuredDatabaseId === undefined ||
      insuredDatabaseId === null ||
      insuredDatabaseId === ""
    ) {
      setInsuredName("N/A");
      return;
    }
    const nc_token = CommonValues.GetNCToken();

    const config = {
      method: "get",
      url: `${process.env.REACT_APP_Nowcerts_Base_Url}Customers/GetCustomers?DatabaseId=${insuredDatabaseId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${nc_token}`,
      },
    };

    axios(config)
      .then((response: any) => {
        const data = response.data
        if (data.length > 0) {
          if (data[0].commercialName != null && data[0].commercialName != "") {
            setInsuredName(data[0].commercialName);
          } else {
            let firstName = data[0].firstName ? data[0].firstName : "";
            let lastName = data[0].lastName ? data[0].lastName : "";
            if (lastName != "") {
              setInsuredName(lastName + ", " + firstName);
            } else {
              setInsuredName(firstName);
            }
          }
        }
        else {
          setInsuredName("N/A");
        }
      })
      .catch((error: any) => {
        setConversationLoading(false);
        setInsuredName("N/A");
        if (error.response.status == 401) {
          CommonValues.Logout(navigate);
        } else {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "Unknown error while getting insured details",
            life: 3000,
          });
        }
      });
  };

    const getConversationHistory = (conversationId: string | null) => {
        if (
            conversationId === undefined ||
            conversationId === null ||
            conversationId === ""
        ) {
            return;
        }
        setConversationLoading(true);
        const token = CommonValues.GetToken();

        const config = {
            method: "get",
            url: `${process.env.REACT_APP_DataFabric_Url}/api/ncmomentumgpt/nc-momentum-gpt-history/${conversationId}`,
            // url: `https://localhost:55723/api/ncmomentumgpt/nc-momentum-gpt-history/${conversationId}`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        };

        axios(config)
            .then((response: any) => {
                const data = response.data.ncMomentumGPTHistoryConversation;
                const fileUrls = response.data.pdfUrls;
                let conversationHistory: ChatResponse[] = [];
                data.forEach((conversation: any) => {
                    let aITool = "";
                    if (
                        conversation.aI_Tool.startsWith("[") &&
                        conversation.aI_Tool.endsWith("]")
                    ) {
                        const aIToolList = JSON.parse(
                            conversation.aI_Tool.replace(/'/g, '"')
                        );
                        aITool = aIToolList[aIToolList.length - 1];
                    } else {
                        aITool = conversation.aI_Tool;
                    }
                    conversationHistory.push({
                        conversationId: conversation.conversationId,
                        // companyId: conversation.companyId,
                        answer: conversation.response,
                        // documents:
                        //     fileUrls.length === 0
                        //         ? []
                        //         : fileUrls.map((file: any) => ({ fileURL: file })),
                        sources: conversation.pageURL,
                        imageURLs: conversation.imageURL,
                        videoURLs: conversation.videoURL,
                        imageSidebar: false,
                        // sourceImageSidebar: false,
                        question: conversation.question,
                        chatId: conversation.chatId,
                        like: conversation.like === null ? false : conversation.like,
                        disLike:
                            conversation.disLike === null ? false : conversation.disLike,
                        feedback: "",
                        showFeedback: false,
                        feedbackLoading: false,
                        plotlyData: { data: "", layout: "" },
                        textToAction: "",
                        responseStreaming: false,
                        // ai_tool: aITool,
                        // insured_id: conversation.insuredId,
                        // policy_id: conversation.policyId,
                        // renewalStatusTemplate: "",
                    });
                });
                setChatResponses(conversationHistory);
                setTimeout(() => {
                    scrollToBottomForQuestion(false);
                    scrollToBottomForAnswer(false);
                }, 100);

                setConversationLoading(false);
            })
            .catch((error: any) => {
                setConversationLoading(false);
                if (error.response.status == 401) {
                    CommonValues.Logout(navigate);
                } else {
                    toast.current.show({
                        severity: "error",
                        summary: "Error",
                        detail: "Unknown error while getting conversation history",
                        life: 3000,
                    });
                }
            });
    };

  useEffect(() => {
    if (chatResponses.length > 1) {
      scrollToBottomForQuestion(true);
      scrollToBottomForAnswer(true);
    }
  }, [chatResponses.length]);

  // Keep all your existing functions exactly as they are
  const startRecordingAudio = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const recorder = new MediaRecorder(stream);
      const audioChunks: any[] = [];

      setRecordingAudio(true);
      setAudioRecorder(recorder);

      recorder.ondataavailable = (e) => {
        audioChunks.push(e.data);
      };

      recorder.onstop = async () => {
        const audioBlob = new Blob(audioChunks, { type: "audio/wav" });
        transcribeAudio(audioBlob);
      };

      recorder.start();
    } catch (err) {
      console.error("Error accessing microphone:", err);
    }
  };

  const stopRecordingAudio = () => {
    if (audioRecorder) {
      audioRecorder.stop();
    }

    setRecordingAudio(false);
  };

  const transcribeAudio = async (audioBlob: Blob) => {
    try {
      setTranscribingAudio(true);
      const data = new FormData();
      var audioFile = new File([audioBlob], "recording.wav", {
        type: audioBlob.type,
      });
      data.append("audioFile", audioFile);

      const token = CommonValues.GetToken();

      const config = {
        method: "post",
        url: `${process.env.REACT_APP_PolicyAgent_Url}/process_audio`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: data,
      };

      axios(config)
        .then((response: any) => {
          setTranscribingAudio(false);
          setQuestion(response.data.result);
        })
        .catch((error: any) => {
          setTranscribingAudio(false);
          if (error.response.status == 401) {
            CommonValues.Logout(navigate);
          } else if (error.response.status == 500) {
            toast.current.show({
              severity: "info",
              detail:
                "Unknown error occured while processing audio. Please try again.",
              life: 3000,
            });
          }
        });
    } catch (error) {
      console.error("Error transcribing audio:", error);
    }
  };
  const uploadFileToBlob = (file: File) => {
    const data = new FormData();
    let conversationId = window.location.href.split("/")[5];
    data.append("formFile", file);

    const token = CommonValues.GetToken();

    const config = {
      method: "post",
      // url: `https://localhost:55723/api/NCMomentumGPT/upload-file/${conversationId}`,
      url: `${process.env.REACT_APP_DataFabric_Url}/api/NCMomentumGPT/upload-file/${conversationId}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };

    axios(config)
      .then((response: any) => {
        const uploadFileResponse: UploadFileResponse = {
          fileName: response.data.fileName,
          fileURL: response.data.fileUrl,
        };
        setUploadFileResponses((prevResponses) => [
          ...prevResponses,
          uploadFileResponse,
        ]);
        setUploadFile((prevResponses) => [...prevResponses, file]);
        setUploadFileToBlobLoading(false);
      })
      .catch((error: any) => {
        setUploadFileToBlobLoading(false);
        if (error.response.status == 401) {
          CommonValues.Logout(navigate);
        } else if (error.response.status == 500) {
          toast.current.show({
            severity: "info",
            summary: "Info",
            detail:
              "Unknown error occured while uploading file. Please try again.",
            life: 3000,
          });
        }
      });
  };

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setUploadFileToBlobLoading(true);

      Array.from(event.target.files).forEach((file: File) => {
        uploadFileToBlob(file);
      });
    } else {
      toast.current.show({
        severity: "info",
        summary: "Info",
        detail: `Select files for uploading.`,
        life: 3000,
      });
    }
    event.target.value = "";
  };

  const removeFile = (fileName: string) => {
    setUploadFile((uploadFiles: File[]) =>
      uploadFiles.filter((file: File) => file.name !== fileName)
    );
    setUploadFileResponses((uploadFileRespones: UploadFileResponse[]) =>
      uploadFileRespones.filter(
        (file: UploadFileResponse) => file.fileName !== fileName
      )
    );
  };

  const handleDrop = (event: React.DragEvent<HTMLTextAreaElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setDragOver(false);
    if (event.dataTransfer.files) {
      setUploadFileToBlobLoading(true);

      Array.from(event.dataTransfer.files).forEach((file: File) => {
        uploadFileToBlob(file);
      });

      // setUploadFileToBlobLoading(false);
    } else {
      toast.current.show({
        severity: "info",
        summary: "Info",
        detail: `Select files for uploading.`,
        life: 3000,
      });
    }
    event.dataTransfer.clearData();
  };

  const onSearch = (event: { query: string }) => {
    const query = event.query.toLowerCase();
    const filteredSuggestions = suggestions.filter((suggestion) =>
      suggestion.nickname.toLowerCase().startsWith(query)
    );
    setSuggestions(filteredSuggestions);
  };

  const itemTemplate = (suggestion: { name: string; nickname: string }) => {
    return (
      <div className="flex align-items-center py-0">
        <span className="flex flex-column ml-2 text-10">
          {suggestion.name}
          <small
            style={{ fontSize: ".75rem", color: "var(--text-color-secondary)" }}
          >
            @{suggestion.nickname}
          </small>
        </span>
      </div>
    );
  };

  // const getConversationHistory = (conversationId: string | null) => {
  //   if (
  //     conversationId === undefined ||
  //     conversationId === null ||
  //     conversationId === ""
  //   ) {
  //     return;
  //   }
  //   setConversationLoading(true);
  //   const token = CommonValues.GetToken();

  //   const config = {
  //     method: "get",
  //     url: `${process.env.REACT_APP_NcSupport_Url}/api/ncsupportbot/nc-support-bot-conversation-history/${conversationId}`,
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: `Bearer ${token}`,
  //     },
  //   };

  //   axios(config)
  //     .then((response: any) => {
  //       const data = response.data;
  //       let conversationHistory: ChatResponse[] = [];
  //       data.forEach((conversation: any) => {
  //         conversationHistory.push({
  //           conversationId: conversation.conversationId,
  //           answer: conversation.response,
  //           sources: conversation.pageURL,
  //           imageURLs: conversation.imageURL,
  //           videoURLs: conversation.videoURL,
  //           imageSidebar: false,
  //           question: conversation.question,
  //           chatId: conversation.chatId,
  //           like: conversation.like === null ? false : conversation.like,
  //           disLike:
  //             conversation.disLike === null ? false : conversation.disLike,
  //           feedback: "",
  //           showFeedback: false,
  //           feedbackLoading: false,
  //           plotlyData: { data: "", layout: "" },
  //           textToAction: "",
  //           responseStreaming: false,
  //         });
  //       });
  //       setChatResponses(conversationHistory);
  //       setTimeout(() => {
  //         scrollToBottomForQuestion(false);
  //         scrollToBottomForAnswer(false);
  //       }, 100);

  //       setConversationLoading(false);
  //     })
  //     .catch((error: any) => {
  //       setConversationLoading(false);
  //       if (error.response.status == 401) {
  //         CommonValues.Logout(navigate);
  //       } else {
  //         toast.current.show({
  //           severity: "error",
  //           detail: "Unknown error while getting conversation history",
  //           life: 3000,
  //         });
  //       }
  //     });
  // };

  const onQuestionChange = (e: any) => {
    setQuestion(e.target.value);
    adjustTextareaHeight();
  };

  const onFeedbackChange = (chatId: string, newFeedback: string) => {
    setChatResponses((prevResponses) =>
      prevResponses.map((response) =>
        response.chatId === chatId
          ? { ...response, feedback: newFeedback }
          : response
      )
    );
  };

  const scrollToBottomForQuestion = (scrollBottom: boolean) => {
    if (chatContainerRef.current) {
      let anchorTags = document.querySelectorAll("a");
      anchorTags.forEach((anchorTag: any) => {
        anchorTag.setAttribute("target", "_blank");
      });
      const lastAnswerElement = document.querySelector(
        ".last-question-block-nc-chat-bot"
      );
      if (lastAnswerElement) {
        const { offsetTop } = lastAnswerElement as HTMLElement;
        chatContainerRef.current.scrollTop = scrollBottom ? offsetTop : 0;
      }
    }
  };

  const scrollToBottomForAnswer = (scrollBottom: boolean) => {
    if (chatContainerRef.current) {
      let anchorTags = document.querySelectorAll("a");
      anchorTags.forEach((anchorTag: any) => {
        anchorTag.setAttribute("target", "_blank");
      });
      chatContainerRef.current.scrollTo({
        top: chatContainerRef.current.scrollHeight,
        behavior: scrollBottom ? "smooth" : "auto",
      });
    }
  };

  const adjustTextareaHeight = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  };

  const onThumbsUpClick = (chatId: string, like: boolean, disLike: boolean) => {
    setChatResponses((prevResponses) =>
      prevResponses.map((response) =>
        response.chatId === chatId
          ? {
            ...response,
            like: like,
            disLike: disLike,
          }
          : response
      )
    );
    updateReaction(chatId, like, disLike);
  };

  const onThumbsDownClick = (
    chatId: string,
    like: boolean,
    disLike: boolean
  ) => {
    setChatResponses((prevResponses) =>
      prevResponses.map((response) =>
        response.chatId === chatId
          ? {
            ...response,
            like: like,
            disLike: disLike,
          }
          : response
      )
    );
    updateReaction(chatId, like, disLike);
  };

  const onFeedbackSubmit = (chatId: string, feedBack: string) => {
    if (feedBack === "" || feedBack === null || feedBack === undefined) {
      return;
    }
    setChatResponses((prevResponses) =>
      prevResponses.map((response) =>
        response.chatId === chatId
          ? { ...response, feedbackLoading: true }
          : response
      )
    );
    updateFeedback(chatId, feedBack);
  };

  const onEnterClick = (e: any) => {
    if (e.keyCode == 13) {
      e.preventDefault();
      sendChatQuestion(question);
    }
  };

  const toggleFeedbackVisibility = (chatId: string) => {
    setChatResponses((prevResponses) =>
      prevResponses.map((response) =>
        response.chatId === chatId
          ? { ...response, showFeedback: !response.showFeedback }
          : response
      )
    );
  };

  const sendChatQuestion = async (que: any) => {
    if (que === "") {
      return;
    }
    const conversationId = window.location.href.split("/")[5];
    const newQuestion: ChatResponse = {
      conversationId: conversationId,
      question: que,
      answer: "",
      sources: [],
      imageURLs: [],
      videoURLs: [],
      imageSidebar: false,
      chatId: "",
      like: false,
      disLike: false,
      feedback: "",
      showFeedback: false,
      feedbackLoading: false,
      plotlyData: { data: "", layout: "" },
      textToAction: "",
      responseStreaming: false,
    };
    let updatedChatResponses = [...chatResponses, { ...newQuestion }];
    setChatResponses(updatedChatResponses);
    setQuestion("");
    scrollToBottomForQuestion(true);
    setQuestionLoading(true);
    const index = chatResponses.length;
    const rateToken = CommonValues.GetRateToken();

    const formData = new FormData();
    formData.append("human_prompt", `${que}`);
    formData.append("file_paths", JSON.stringify(uploadFileResponses));
    formData.append("nc_token", localStorage.getItem("NCToken") || "");
    formData.append("conversationId", conversationId);
    formData.append("ai_service", "AI_INSURED_CONTEXT_CHAT");
    formData.append("rate_token", rateToken || "");
    formData.append(
      "nowcerts_ams_url",
      window.location.ancestorOrigins[0] || "https://newtest.nowcerts.com"
    );
    formData.append("insured_database_id", insuredDatabaseId || "");
    const token = CommonValues.GetToken();
    try {
      const ctrl = new AbortController();
      await fetchEventSource(
        `${process.env.REACT_APP_MomentumGPT}/api/insured/context-chat`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
          signal: ctrl.signal,
          openWhenHidden: true,
          onopen(response: Response): Promise<void> {
            if (response.status === 401) {
              CommonValues.Logout(navigate);
            } else if (response.status !== 200) {
              setQuestionLoading(false);
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: "Unknown error while sending question",
                life: 3000,
              });
            }
            return Promise.resolve();
          },
          onmessage(event: any) {
            let responseObject = JSON.parse(event.data);
            if (responseObject.response !== "") {
              setQuestionLoading(false);
            }

            updatedChatResponses = updatedChatResponses.map(
              (chatResponse, index) => {
                if (index === updatedChatResponses.length - 1) {
                  return {
                    ...chatResponse,
                    answer:
                      (chatResponse.answer || "") + responseObject.response,
                    chatId: responseObject.chatId,
                    documents: responseObject.files,
                    sources: responseObject.pageURL,
                    imageURLs: responseObject.imageURL,
                    videoURLs: responseObject.videoURL,
                    ai_tool: responseObject.ai_tool,
                    insured_id: responseObject.insuredClientId,
                    policy_id: responseObject.policyId,
                    responseStreaming: responseObject.responseStreaming,
                  };
                }
                return chatResponse;
              }
            );

            if (responseObject.error_message !== "") {
              let lastIndex = updatedChatResponses.length - 1;
              updatedChatResponses[lastIndex].answer =
                responseObject.error_message;
              ctrl.abort();
            }

            setChatResponses(updatedChatResponses);

            let anchorTags = document.querySelectorAll("a");
            anchorTags.forEach((anchorTag: any) => {
              anchorTag.setAttribute("target", "_blank");
            });
          },
          onclose() {
            setQuestionLoading(false);
            setSendQuestion(true);
          },
          onerror(error: any) {
            if (error instanceof Response) {
              if (error.status === 504) {
                console.error("504 Gateway Timeout encountered");
                return;
              }

              console.error(`HTTP error ${error.status}:`, error.statusText);
            } else {
              console.error("Non-HTTP error occurred:", error);
            }
            setQuestionLoading(false);
            setSendQuestion(true);
          },
        }
      );
    } catch (error: any) { }
  };

  const updateReaction = (chatId: string, like: boolean, disLike: boolean) => {
    const token = CommonValues.GetToken();

    const data = {
      ChatId: chatId,
      Like: like,
      DisLike: disLike,
    };

    const config = {
      method: "put",
      url: `${process.env.REACT_APP_NcSupport_Url}/api/ncsupportbot/nc-support-bot-reaction`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };

    axios(config)
      .then((response: any) => { })
      .catch((error: any) => {
        if (error.response.status == 401) {
          CommonValues.Logout(navigate);
        } else {
          toast.current.show({
            severity: "error",
            detail: "Unknown error while updating reaction",
            life: 3000,
          });
        }
      });
  };

  const updateFeedback = (chatId: string, feedBack: string) => {
    const token = CommonValues.GetToken();

    const data = {
      ChatId: chatId,
      Feedback: feedBack,
    };

    const config = {
      method: "put",
      url: `${process.env.REACT_APP_NcSupport_Url}/api/ncsupportbot/nc-support-bot-feedback`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };

    axios(config)
      .then((response: any) => {
        if (feedBack !== "" && feedBack !== null && feedBack !== undefined) {
          toast.current.show({
            severity: "success",
            detail: "Feedback saved successfully.",
            life: 3000,
          });
          setChatResponses((prevResponses) =>
            prevResponses.map((response) =>
              response.chatId === chatId
                ? {
                  ...response,
                  feedback: "",
                  showFeedback: false,
                  feedbackLoading: false,
                }
                : response
            )
          );
        }
      })
      .catch((error: any) => {
        setChatResponses((prevResponses) =>
          prevResponses.map((response) =>
            response.chatId === chatId
              ? { ...response, feedbackLoading: false }
              : response
          )
        );
        if (error.response.status == 401) {
          CommonValues.Logout(navigate);
        } else {
          toast.current.show({
            severity: "error",
            detail: "Unknown error while updating feedback",
            life: 3000,
          });
        }
      });
  };

  const onCopyResponseClick = (copiedData: string) => {
    const htmlContent: any = marked(copiedData);
    const plainTextContent = htmlToPlainTextWithFormatting(htmlContent);

    const htmlBlob = new Blob([htmlContent], { type: "text/html" });
    const textBlob = new Blob([plainTextContent], { type: "text/plain" });

    const clipboardItem = new ClipboardItem({
      "text/plain": textBlob,
      "text/html": htmlBlob,
    });

    try {
      navigator.clipboard.write([clipboardItem]).then(
        () => {
          toast.current.show({
            severity: "success",
            detail: "Copied  Successfully!",
            life: 3000,
          });
        },
        (err) => {
          console.error("Failed to copy text: ", err);
          toast.current.show({
            severity: "error",
            detail: "Unknown error occurred while coping data",
            life: 3000,
          });
        }
      );

      return true;
    } catch (err) {
      console.error("Failed to copy content: ", err);
      toast.current.show({
        severity: "error",
        detail: "Unknown error occurred while coping data",
        life: 3000,
      });
      return false;
    }
  };

  const htmlToPlainTextWithFormatting = (html: any) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    const elementsToReplace = tempDiv.querySelectorAll(
      "br, p, h1, h2, h3, h4, h5, h6"
    );
    elementsToReplace.forEach((element: any) => {
      const lineBreak = document.createTextNode("\n");
      element.parentNode.insertBefore(lineBreak, element);
    });

    return tempDiv.textContent || tempDiv.innerText || "";
  };
  const showImageSidebar = (index: number, isHidden: boolean) => {
    const updatedChatResponses = [...chatResponses];
    updatedChatResponses[index].imageSidebar = isHidden;
    setChatResponses(updatedChatResponses);
  };

  return (
    <div className="landing-page">
      <Toast ref={toast} />

      {/* Header Section - Fixed at top */}
      <div
        className="chat-app-header"
        style={{ minHeight: `${chatBotEmbeded ? "6.4vh" : "7.7vh"}` }}
      >
        <Header
          setShowConversationHistory={setShowConversationHistory}
          chatBotEmbeded={chatBotEmbeded}
          onFreshDeskClick={onFreshDeskClick}
          isPinned={isPinned}
          onPinToggleClick={onPinToggleClick}
        />
        {/* Insured Name Display */}
        <div className="insured-display-container">
          <label className="insured-display-label">
            Insured:
          </label>
          <input 
            type="text" 
            value={insuredName}
            readOnly
            className="insured-display-input"
            placeholder="Loading insured information..."
          />
        </div>
      </div>

      {/* Main Chat Container - Flex layout */}
      <div
        className="chat-app-main-container"
        style={{ height: `${chatBotEmbeded ? "93.6vh" : "92.3vh"}` }}
      >
        <div
          className={`row mx-auto h-100 ${chatBotEmbeded
            ? "nc-chat-bot-main-div-embeded"
            : "nc-chat-bot-main-div"
            }`}
        >
          {/* Conversation History Sidebar */}
          {/* {showConversationHistory && chatBotEmbeded && (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 nc-chat-bot-main-div-embeded">
              <NCChatBotConversationHistory
                setShowConversationHistory={setShowConversationHistory}
                chatBotEmbeded={chatBotEmbeded}
              />
            </div>
          )} */}

          {/* Main Chat Area for Embedded */}
          {!showConversationHistory && chatBotEmbeded && (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 h-100 d-flex flex-column">
              {/* Chat Messages Container - Scrollable */}
              <div
                ref={chatContainerRef}
                className="chat-messages-container flex-grow-1 overflow-auto p-4"
              >
                {!conversationLoading &&
                  chatResponses.length > 0 &&
                  chatResponses.map((response, index) => {
                    const isLastAnswer = index === chatResponses.length - 1;

                    return (
                      <div
                        key={response.chatId}
                        className={`col-12 mb-4 ${isLastAnswer && !questionLoading
                          ? "last-answer-block-nc-chat-bot"
                          : "question-answer-block"
                          }`}
                      >
                        <div className="d-flex flex-direction-row align-items-center">
                          {!chatBotEmbeded && (
                            <span className="me-1 avtar border-rounded">
                              {avatarName}
                            </span>
                          )}
                          <div className="mb-1 text-14 nc-chat-bot-question">
                            <b>{response.question}</b>
                          </div>
                        </div>
                        <div className="d-flex flex-direction-row">
                          {!chatBotEmbeded && (
                            <span className="me-1">
                              <img
                                alt="NowCerts Logo"
                                src={AnswerIcon}
                                className="me-2"
                                height={28}
                              />
                            </span>
                          )}
                          {isLastAnswer && questionLoading ? (
                            <div className="row w-100">
                              <div className="col-12">
                                <Skeleton className="mb-2"></Skeleton>
                              </div>
                              <div className="col-12">
                                <Skeleton
                                  width="70%"
                                  className="mb-2 d-block"
                                ></Skeleton>
                              </div>
                              <div className="col-12">
                                <Skeleton
                                  width="40%"
                                  className="mb-2 d-block"
                                ></Skeleton>
                              </div>
                              <div className="col-12">
                                <Skeleton
                                  width="20%"
                                  className="mb-2 d-block"
                                ></Skeleton>
                              </div>
                            </div>
                          ) : (
                            <Answer
                              chatResponse={response}
                              index={index}
                              chatBotEmbeded={chatBotEmbeded}
                              sendQuestion={sendChatQuestion}
                              onFeedbackSubmit={onFeedbackSubmit}
                              onFeedbackChange={onFeedbackChange}
                              toggleFeedbackVisibility={
                                toggleFeedbackVisibility
                              }
                              onCopyResponseClick={onCopyResponseClick}
                              onThumbsUpClick={onThumbsUpClick}
                              onThumbsDownClick={onThumbsDownClick}
                              showImageSidebar={showImageSidebar}
                            />
                          )}
                        </div>
                      </div>
                    );
                  })}

                {conversationLoading ? (
                  <div className="col chat-bot-response-area-loader-placeholder d-flex justify-content-center align-items-center">
                    <div className="d-flex justify-content-center">
                      <SupportLoader />
                    </div>
                  </div>
                ) : (
                  chatResponses.length === 0 && (
                    <div className="ql-cs-welcome-container h-100 d-flex flex-column justify-content-center">
                      <div className="ql-cs-welcome-section">
                        <div className="ql-cs-welcome-title text-center mb-4">
                          Ask questions about this insured to Momentum AI
                        </div>

                        <div className="ql-cs-suggestions-grid">
                          {suggestedQuestions.map(
                            (suggestedQuestion: string, index: number) => {
                              return (
                                <div
                                  key={index}
                                  className="ql-cs-suggestion-card"
                                  onClick={() =>
                                    sendChatQuestion(suggestedQuestion)
                                  }
                                >
                                  <span className="ql-cs-suggestion-text">
                                    {suggestedQuestion}
                                  </span>
                                </div>
                              );
                            }
                          )}
                          {/* <button
                            className="ql-cs-human-cta"
                            onClick={onFreshDeskClick}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="18"
                              viewBox="0 0 20 20"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="1"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <circle cx="12" cy="7" r="4" />
                              <path d="M5.5 21c1.5-3 4.5-5 6.5-5s5 2 6.5 5" />
                            </svg>
                            <span>Chat with a human</span>
                          </button> */}
                        </div>
                      </div>
                    </div>
                  )
                )}
              </div>

              <div className="bg-white ">
                <div className="momentum-chat-container">
                  {/* Uploaded Files Display - Above Text Input */}
                  {(uploadFile.length > 0 || uploadFileToBlobLoading) && (
                    <div className="d-flex justify-content-end mb-2 px-3">
                      {uploadFileToBlobLoading ? (
                        <div className="d-flex align-items-center">
                          <SupportLoader />
                        </div>
                      ) : (
                        <div className="d-flex flex-wrap justify-content-end gap-2">
                          {uploadFile?.map((file: File) => {
                            let fileUrl = "";
                            uploadFileResponses.forEach(
                              (item: UploadFileResponse) => {
                                if (item.fileName === file.name) {
                                  fileUrl = item.fileURL;
                                }
                              }
                            );

                            return (
                              <div
                                key={file.name}
                                className="d-flex align-items-center border bg-white p-1 rounded text-14"
                                title={file.name}
                                style={{ maxWidth: "200px" }}
                              >
                                {file.name.toLowerCase().endsWith(".pdf") ? (
                                  <svg
                                    className="mx-1"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  >
                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                    <polyline points="14,2 14,8 20,8" />
                                    <line x1="16" y1="13" x2="8" y2="13" />
                                    <line x1="16" y1="17" x2="8" y2="17" />
                                    <polyline points="10,9 9,9 8,9" />
                                  </svg>
                                ) : (
                                  <img
                                    className="mx-1"
                                    src={fileUrl || ""}
                                    width={20}
                                    alt="File thumbnail"
                                    onError={(e) => {
                                      const target =
                                        e.target as HTMLImageElement;
                                      target.style.display = "none";
                                    }}
                                  />
                                )}
                                <span
                                  className="text-truncate text-muted mx-2"
                                  style={{ maxWidth: "120px" }}
                                >
                                  {file.name.length > 15
                                    ? `${file.name.substring(
                                      0,
                                      12
                                    )}...${file.name.split(".").pop()}`
                                    : file.name}
                                </span>
                                <button
                                  className="btn p-0 text-danger"
                                  title="Remove"
                                  onClick={() => removeFile(file.name)}
                                  style={{ lineHeight: 1 }}
                                >
                                  ✖
                                </button>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  )}

                  <div
                    className={`momentum-input-wrapper ${isFocused ? "focused" : ""
                      }`}
                  >
                    <div className="momentum-input-inner">
                      <textarea
                        ref={textareaRef}
                        placeholder="Message Momentum AI..."
                        name="question"
                        value={question}
                        className="momentum-textarea"
                        onChange={onQuestionChange}
                        rows={1}
                        onKeyDown={onEnterClick}
                        style={{
                          minHeight: "56px",
                          maxHeight: "200px",
                        }}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        onDragOver={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setDragOver(true);
                        }}
                        onDragEnter={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setDragOver(true);
                        }}
                        onDragLeave={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setDragOver(false);
                        }}
                        onDrop={handleDrop}
                      />

                      <div className="momentum-actions">
                        {/* File Upload Input */}
                        <input
                          className="d-none"
                          type="file"
                          id="fileUploadInput"
                          name="filefield"
                          accept="application/pdf, image/png, image/jpeg, .csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                          onChange={handleFileUpload}
                          multiple
                        />
                        <label className="momentum-button idle" htmlFor="fileUploadInput" title="Upload File">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                          </svg>
                        </label>

                        {/* <button
                          onClick={onFreshDeskClick}
                          className="momentum-button idle"
                            width="22"
                            height="22"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <circle cx="12" cy="7" r="4" />
                            <path d="M5.5 21c1.5-3 4.5-5 6.5-5s5 2 6.5 5" />
                          </svg>
                        </button> */}
                        {transcribingAudio ? (
                          <div className="momentum-button transcribing">
                            <SupportLoader />
                          </div>
                        ) : recordingAudio ? (
                          <button
                            onClick={stopRecordingAudio}
                            className="momentum-button recording"
                            title="Stop Recording"
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"
                                fill="currentColor"
                              />
                              <path
                                d="M19 10v2a7 7 0 0 1-14 0v-2"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                              <line
                                x1="12"
                                x2="12"
                                y1="19"
                                y2="22"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                            </svg>
                          </button>
                        ) : (
                          <button
                            onClick={startRecordingAudio}
                            className="momentum-button idle"
                            title="Voice Input"
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"
                                stroke="currentColor"
                                strokeWidth="2"
                              />
                              <path
                                d="M19 10v2a7 7 0 0 1-14 0v-2"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                              <line
                                x1="12"
                                x2="12"
                                y1="19"
                                y2="22"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                            </svg>
                          </button>
                        )}

                        <button
                          onClick={() => sendChatQuestion(question)}
                          className={`momentum-button send ${question.length > 0 ? "active" : "disabled"
                            }`}
                          title="Send Message"
                          disabled={question.length === 0}
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z"
                              fill="currentColor"
                            />
                            <path
                              d="m21.854 2.147-10.94 10.939"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="momentum-info-centered">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                      <circle
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="2"
                      />
                      <path
                        d="m9 12 2 2 4-4"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>
                      Support Bot can make mistakes. Check important info.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Non-Embedded Layout - Keep your existing structure for non-embedded version */}
          {!chatBotEmbeded && (
            <>
              <div className="col-lg-2 col-md-2 col-sm-2 col-2"></div>
              <div className="col-lg-8 col-md-8 col-sm-8 col-8 p-4">
                {!conversationLoading &&
                  chatResponses.length > 0 &&
                  chatResponses.map((response, index) => {
                    const isLastAnswer = index === chatResponses.length - 1;

                    return (
                      <div
                        key={response.chatId}
                        className={`col-12 ${isLastAnswer && !questionLoading
                          ? "last-answer-block-nc-chat-bot"
                          : "question-answer-block"
                          }`}
                        style={
                          isLastAnswer && !questionLoading
                            ? { paddingBottom: `${bottomPadding}px` }
                            : {}
                        }
                      >
                        <div className="d-flex flex-direction-row align-items-center">
                          {!chatBotEmbeded && (
                            <span className="me-1 avtar border-rounded">
                              {avatarName}
                            </span>
                          )}
                          <div className="mb-1 text-14 nc-chat-bot-question">
                            <b>{response.question}</b>
                          </div>
                        </div>
                        <div className="d-flex flex-direction-row">
                          {!chatBotEmbeded && (
                            <span className="me-1">
                              <img
                                alt="NowCerts Logo"
                                src={AnswerIcon}
                                className="me-2"
                                height={28}
                              />
                            </span>
                          )}
                          {isLastAnswer && questionLoading ? (
                            <div className="row w-100">
                              <div className="col-12">
                                <Skeleton className="mb-2"></Skeleton>
                              </div>
                              <div className="col-12">
                                <Skeleton
                                  width="70%"
                                  className="mb-2 d-block"
                                ></Skeleton>
                              </div>
                              <div className="col-12">
                                <Skeleton
                                  width="40%"
                                  className="mb-2 d-block"
                                ></Skeleton>
                              </div>
                              <div className="col-12">
                                <Skeleton
                                  width="20%"
                                  className="mb-2 d-block"
                                ></Skeleton>
                              </div>
                            </div>
                          ) : (
                            <Answer
                              chatResponse={response}
                              index={index}
                              chatBotEmbeded={chatBotEmbeded}
                              sendQuestion={sendChatQuestion}
                              onFeedbackSubmit={onFeedbackSubmit}
                              onFeedbackChange={onFeedbackChange}
                              toggleFeedbackVisibility={
                                toggleFeedbackVisibility
                              }
                              onCopyResponseClick={onCopyResponseClick}
                              onThumbsUpClick={onThumbsUpClick}
                              onThumbsDownClick={onThumbsDownClick}
                              showImageSidebar={showImageSidebar}
                            />
                          )}
                        </div>
                      </div>
                    );
                  })}

                {conversationLoading ? (
                  <div className="col chat-bot-response-area-loader-placeholder d-flex justify-content-center align-items-center">
                    <div className="d-flex justify-content-center">
                      <SupportLoader />
                    </div>
                  </div>
                ) : (
                  chatResponses.length === 0 && (
                    <div className="row chat-bot-response-area-loader-placeholder d-flex justify-content-center align-items-center">
                      <div className="col-12 col-md-12 col-sm-12 col-lg-12 text-16 text-center mb-4">
                        <h4>Ask questions about this insured to Momentum AI</h4>
                      </div>
                      {suggestedQuestions.map(
                        (suggestedQuestion: string, index: number) => {
                          let isLast = index === suggestedQuestions.length - 1;
                          return (
                            <>
                              {!isLast && index % 2 === 0 && (
                                <div className="col-6 col-sm-6 col-md-3 col-lg-3 text-end">
                                  <div
                                    className="sources-box me-3"
                                    onClick={() =>
                                      sendChatQuestion(suggestedQuestion)
                                    }
                                  >
                                    <span className="ai-border-radius p-2 text-muted small bg-momentum-light d-inline shadow-sm mb-2 me-2 text-14 d-flex">
                                      <span className="text-14">
                                        {suggestedQuestion}
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              )}
                              {!isLast && index % 2 != 0 && (
                                <div className="col-6 col-sm-6 col-md-3 col-lg-3">
                                  <div
                                    className="sources-box me-3"
                                    onClick={() =>
                                      sendChatQuestion(suggestedQuestion)
                                    }
                                  >
                                    <span className="ai-border-radius p-2 text-muted small bg-momentum-light d-inline shadow-sm mb-2 me-2 text-14 d-flex">
                                      <span className="text-14">
                                        {suggestedQuestion}
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              )}
                              {isLast && (
                                <div className="col-12 col-sm-12 col-md-2 col-lg-12 text-center">
                                  <div
                                    className="sources-box me-3"
                                    onClick={() =>
                                      sendChatQuestion(suggestedQuestion)
                                    }
                                  >
                                    <span className="ai-border-radius p-2 text-muted small bg-momentum-light d-inline shadow-sm mb-2 me-2 text-14 d-flex">
                                      <span className="text-14">
                                        {suggestedQuestion}
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              )}
                            </>
                          );
                        }
                      )}
                    </div>
                  )
                )}
              </div>
              <div className="col-lg-2 col-md-2 col-sm-2 col-2"></div>
            </>
          )}
        </div>
      </div>

      {!chatBotEmbeded && (
        <div style={{ minHeight: "12.6vh" }}>
          <div className="question-text">
            <div className="position-relative question-text-div">
              <div className="row">
                {
                  <div
                    className={`${showConversationHistory
                      ? "col-lg-4 col-md-4 col-sm-4 col-4"
                      : "col-lg-3 col-md-3 col-sm-3 col-3"
                      }`}
                  ></div>
                }
                <div
                  className={`${chatBotEmbeded
                    ? "col-lg-10 col-md-10 col-sm-10 col-10"
                    : "col-lg-7 col-md-7 col-sm-7 col-7"
                    }`}
                >
                  <div className="row">
                    {showConversationHistory && (
                      <div className="col-lg-1 col-md-1 col-sm-1 col-1"></div>
                    )}
                    <div
                      className={`${showConversationHistory
                        ? "col-lg-10 col-md-10 col-sm-10 col-10"
                        : "col-lg-12 col-md-12 col-sm-12 col-12"
                        }`}
                    >
                      {transcribingAudio ? (
                        <span
                          className={`${showConversationHistory
                            ? "audio-icon-on-show-conversation-history"
                            : "audio-icon-nc-chat-bot"
                            }`}
                        >
                          <ThreeDots height="35" width="45" color="#2dacc2" />
                        </span>
                      ) : recordingAudio ? (
                        <i
                          className={`fa fa-stop-circle ${showConversationHistory
                            ? "audio-icon-on-show-conversation-history"
                            : "audio-icon-nc-chat-bot"
                            }`}
                          onClick={stopRecordingAudio}
                          style={{
                            fontSize: "xx-large",
                            left: `${chatBotEmbeded ? "7%" : ""}`,
                          }}
                        ></i>
                      ) : (
                        <i
                          title="Speech to text"
                          className={`fa fa-microphone ${showConversationHistory
                            ? "audio-icon-on-show-conversation-history"
                            : "audio-icon-nc-chat-bot"
                            }`}
                          onClick={startRecordingAudio}
                          style={{
                            fontSize: "xx-large",
                            left: `${chatBotEmbeded ? "7%" : ""}`,
                          }}
                        ></i>
                      )}
                      <Mention
                        value={question}
                        onChange={onQuestionChange}
                        suggestions={suggestions}
                        onSearch={onSearch}
                        field="nickname"
                        placeholder="Ask me anything about NowCerts..."
                        rows={2}
                        itemTemplate={itemTemplate}
                        name="question"
                        className="nc-chat-bot-mention-textarea"
                        maxLength={2000}
                        style={{
                          minHeight: `${Math.max(2, question.length / 150)}em`,
                        }}
                        onKeyDown={onEnterClick}
                      />
                      <span className="info-msg mb-2">
                        Support Bot can make mistakes. Check important info.
                      </span>
                      <img
                        src={CommunicationIcon}
                        onClick={() => sendChatQuestion(question)}
                        className={`${showConversationHistory
                          ? "communication-icon-on-show-conversation-history"
                          : "communication-icon-nc-chat-bot"
                          }`}
                        style={{ right: `${chatBotEmbeded ? "7%" : ""}` }}
                      />
                    </div>
                  </div>
                  {showConversationHistory && (
                    <div className="col-lg-1 col-md-1 col-sm-1 col-1"></div>
                  )}
                </div>

                <div
                  className={`col-lg-${chatBotEmbeded ? "1" : showConversationHistory ? "1" : "3"
                    } col-md-${chatBotEmbeded ? "1" : showConversationHistory ? "1" : "3"
                    } col-sm-${chatBotEmbeded ? "1" : showConversationHistory ? "1" : "3"
                    } col-${chatBotEmbeded ? "1" : showConversationHistory ? "1" : "3"
                    }`}
                ></div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
